import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../common/global-variables';
import { Service } from '../network.service';
import { AppState } from '../../../app.service';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { truncateString } from '../../dataprotection/dataprotection-common/common-renderers';
import { Subscription } from 'rxjs/Rx';
import { RefreshSharedService } from '../../../refresh-shared-service';
import { setVcdRedirectUrlCookie } from '../../../../common/utils/utils';
var $ = require('jquery');

@Component({
  selector: 'org-vdc-network-detail',
  styles: [require('../network.scss')],
  template: require('./org-vdc-networks.html'),
  providers: [
    Service, TranslateService
  ],
})

export class OrgVdcNetworkDetail {
    private vdcsList: any;
    private isTranslationready:boolean = true;
    private subscribeHandler;
    private orgVDCId: string;
    private cardClass: string = 'org-vdc-details';
    private loaded: boolean = false;
    private rsService: RefreshSharedService;
    private refreshSubscription: Subscription;
    private currentClassName: string = '';

    constructor(public appState: AppState,
                public service: Service,
                private translate: TranslateService,
                private route: ActivatedRoute,
                private rss: RefreshSharedService) {
        translate.use(GlobalVariables.LOCALE);
        this.rsService = rss;
        this.currentClassName = 'OrgVdcNetworkDetail';
    }


    ngOnInit() {
        this.refreshSubscription = this.rsService.getRefreshParam()
        .subscribe (
        item => {
            this.handleEmittedValues(item);
        });
        this.route.params.forEach((params: Params) => {
            this.orgVDCId = params['id'];
            this.rsService.setParam({
                'loadedComponent': this.currentClassName,
                'detailPageIDName': this.orgVDCId,
                'shouldReloadInventoryTree': true
            });
            this.vdcsList = [];
            this.getVDCsList();
        });
    }

    handleEmittedValues(item) {
        if (item.detailPageIDName === this.orgVDCId) {
            this.vdcsList = [];
            this.getVDCsList();
        }
    }

    getVDCsList() {
        this.loaded = false;
        this.subscribeHandler = this.service.getVDCsList()
        .subscribe(
            (vdcsList: any) => {
            this.vdcsList = [];
            for (let i = 0; i < vdcsList.length; i++) {
                if (vdcsList[i].objectId === this.orgVDCId) {
                    this.vdcsList = [vdcsList[i]];
                    this.loaded = true;
                    break;
                }
            }
            },
            error => this.service.logError(error, 'get Orgs error'),
            () => this.service.logOperationCompleted('get Orgs Completed')
        );
    }

    getTitle() {
        return (this.translate.instant('orgNetwork.organizationNetwork'));
    }

    truncateName(txt) {
        return truncateString(txt, 20, "tooltip tooltip-md tooltip-bottom-right");
    }

    ngOnDestroy() {
        this.rsService.resetParam();
        if (this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }
    }

    onMangeInVcd = ($event, ssoUrl: string, orgName: string) => {
        if (ssoUrl) {
            setVcdRedirectUrlCookie(orgName, ssoUrl);
            window.open(ssoUrl, '_blank');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/network/org-vdc-networks/org-vdc-network-detail.ts